.references {
  min-inline-size: 0;
  overflow-wrap: anywhere;
}

/* Legal references must remain readable inside narrow cards in both apps. */
.references .referenceLink {
  max-inline-size: 100%;
  flex-shrink: 1;
  white-space: normal;
}
